export default {
  global: {},
};
